var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFactoryDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "160.000000pt",
    height: "200.000000pt",
    viewBox: "0 0 160.000000 200.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,200.000000) scale(0.100000,-0.100000)",
    fill: "#fff",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1190 1504 c1 -273 0 -498 -2 -500 -2 -2 -44 78 -93 176 -49 99 -92 180 -95 180 -3 0 -48 -85 -100 -190 -52 -104 -97 -190 -100 -190 -3 0 -48 86 -100 190 -52 105 -97 190 -100 190 -3 -1 -47 -86 -98 -190 -52 -105 -97 -190 -100 -190 -4 0 -38 64 -77 143 -38 78 -82 164 -96 191 l-27 49 -101 -201 -101 -202 0 -480 0 -480 800 0 800 0 0 1000 0 1000 -205 0 -206 0 1 -496z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFactoryDark);
export default __webpack_public_path__ + "static/media/factory_dark.d739c5fc671bd2c953e6d498007723fb.svg";
export { ForwardRef as ReactComponent };